export const coverNoImage =
    "https://via.placeholder.com/180x250/566273/FFFFFF?text=no%20image";
